import styled from '@emotion/styled'
import useMediaQuery from 'app/utils/useMediaQuery'
import { motion } from 'framer-motion'
import React, { memo } from 'react'
import { useInView } from 'react-intersection-observer'

export interface Props {
  className?: string
  childClassName?: string
  delay?: number
  length?: number
  tag?: keyof JSX.IntrinsicElements
  text: string
}

export const AnimatedTitle = memo(function AnimatedTitle({
  className,
  childClassName,
  delay,
  length = 20,
  tag: Container = 'div',
  text,
}: Props) {
  const [ref, isVisible] = useInView({
    threshold: 0.25,
    triggerOnce: true,
  })

  const isMobile = useMediaQuery('(max-width: 1199px)')

  const variants = {
    visible: (i: any) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.4 + (delay ? delay : 0),
        ease: [0.455, 0.03, 0.515, 0.955],
        duration: 1.5,
      },
    }),
    hidden: {
      opacity: 0,
      y: 90,
      transition: {
        delay: 0,
        duration: 0,
      },
    },
  }

  function splitter(str: string, l: number) {
    var strs = []
    while (str.length > l) {
      var pos = str.substring(0, l).lastIndexOf(' ')
      pos = pos <= 0 ? l : pos
      strs.push(str.substring(0, pos))

      var i = str.indexOf(' ', pos) + 1
      if (i < pos || i > pos + l) i = pos
      str = str.substring(i)
    }
    strs.push(str)
    return strs
  }

  return (
    <Container className={className}>
      {splitter(text, !isMobile ? length : 100).map((line, index) => (
        <Wrapper key={line + index} ref={ref}>
          <Line
            animate={isVisible ? 'visible' : 'hidden'}
            className={childClassName}
            custom={index}
            dangerouslySetInnerHTML={{ __html: line }}
            ref={ref}
            variants={variants}
          />
        </Wrapper>
      ))}
    </Container>
  )
})

const Wrapper = styled.div`
  overflow: hidden;
`

const Line = styled(motion.div)``
